export default "__VITE_ASSET__d31dae42__"